const ErrorComponent = (): JSX.Element => (
  <h1
    style={{
      left: '50%',
      position: 'absolute',
      top: '50%',
      transform: 'translate(-50%, -50%)',
    }}
  >
    Error 500
  </h1>
);

export default ErrorComponent;
